import React, { useEffect } from 'react';
import images from '../images';
import styles from '../css/Hero.module.scss'
import { Contador } from './Contador';
export const Hero = () => {
    return (
        <>
            <div className={'container-fluid px-5 ' + styles.imagenFondo}>
                <div className='row align-items-center h-100'>
                    <div className='col-7 text-white '>
                        <h1 className={'mb-0 fw-bold ' + styles.titulo}>AL SERVICIO DE LA INDUSTRIA</h1>
                        <img className={styles.subrayado} src={images.otros.subrayado} />
                        <p className={'mb-5 mt-4 ' + styles.subtitulo}>ENCONTRÁ LO QUE BUSCAS EN NUESTRA AMPLIA GAMA DE PRODUCTOS </p>
                        <Contador texto={'Años de experiencia'} numero={20} esPrimero={true} />
                        <Contador texto={'Productos de calidad'} numero={400} />
                        <Contador texto={'Clientes Felices'} numero={15000} />
                    </div>
                </div>
            </div>
        </>
    )

}